import { StyledLoginAsSuperAdmin, Styledloginbg, StyledLoginButtonLogin, StyledLoginMainContent, StyledLoginMainHeading, StyledLoginName, StyledLoginNameInput, StyledLoginPassword, StyledLoginPasswordInput } from "./style.login";

const ForgotPassword = () => {

    return (

    <>
       <Styledloginbg>
              <StyledLoginMainContent>
                <StyledLoginMainHeading>Reset Password</StyledLoginMainHeading>
                <StyledLoginName>New Password</StyledLoginName>
      
                <StyledLoginNameInput/>
                <StyledLoginPassword>Repeat Password</StyledLoginPassword>
                <StyledLoginPasswordInput/>
                
                <StyledLoginButtonLogin >Reset Password</StyledLoginButtonLogin>
      
                <StyledLoginAsSuperAdmin>
                  
                </StyledLoginAsSuperAdmin>
              </StyledLoginMainContent>
            </Styledloginbg>
    </>

    )
}

export default  ForgotPassword;